<script>
import { i18n, setLocale } from "@v2/shared/config";

export default {
  name: "NotAuthHeader",
  props: {
    simple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentLocale() {
      return i18n.locale;
    },

    nextLocale() {
      switch (this.currentLocale) {
        case "ru":
          return "en";

        case "en":
          return "ru";
      }

      return "ru";
    }
  },

  methods: {
    changeLocale() {
      setLocale(this.nextLocale);
    }
  }
};
</script>

<template>
  <header class="app-header-auth">
    <div class="container app-header-auth__container">
      <ul v-if="!simple" class="app-header-auth__navigation">
        <li
          class="app-header-auth__navigation-item app-header-auth__navigation-item_logo"
        >
          <router-link
            :to="{ name: 'login' }"
            class="app-header-auth__navigation-item-link"
          >
            <icon :name="`logo-${currentLocale}`" class="svg-icon--logo" />
          </router-link>
        </li>

        <li
          class="app-header-auth__navigation-item app-header-auth__navigation-item_lk"
        >
          <router-link
            :to="{ name: 'login' }"
            class="app-header-auth__navigation-item-link"
          >
            {{ $t("common.expoName") }}
          </router-link>
        </li>
      </ul>
      <ul v-else class="app-header-auth__navigation">
        <li
          class="app-header-auth__navigation-item app-header-auth__navigation-item_logo-small"
        >
          <icon :name="`logo-${currentLocale}`" class="svg-icon--logo" />
        </li>
      </ul>
      <ul class="app-header-auth__navigation">
        <li
          class="app-header-auth__navigation-item app-header-auth__navigation-item_lang"
        >
          <a
            href="#"
            class="app-header-auth__navigation-item-link"
            @click.prevent="changeLocale(nextLocale)"
          >
            {{ nextLocale }}
          </a>
        </li>
      </ul>
    </div>
  </header>
</template>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";

.app-header-auth {
  background: #005197;

  &__container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    height: 56px;

    @include respond-down(md) {
      height: auto;
      padding-top: 15px;
      align-items: flex-start;
    }
  }

  &__navigation {
    display: flex;
    align-items: center;

    height: 100%;

    list-style: none;

    margin: 0;
    padding: 0;

    @include respond-down(md) {
      flex-direction: column;
      align-items: flex-start;
    }

    &-item {
      letter-spacing: -0.13px;
      font-size: 14px;
      color: #7ca4c7;

      &:hover {
        color: #fff;
      }

      &-link {
        color: inherit;
        text-decoration: none;
        text-transform: capitalize;

        display: flex;
        align-items: center;

        > svg {
          margin-right: 9px;
        }

        @include respond-down(md) {
          > svg {
            margin-right: 0;
          }
        }
      }
      &_logo-small {
        svg {
          width: 138px;
          height: 28px;

          color: #fff;
        }
      }
      &_logo {
        position: relative;
        margin-right: 0;

        svg {
          width: 138px;
          height: 28px;

          color: #fff;
        }

        @include respond-up(md) {
          &::after {
            content: "";

            display: block;

            width: 2px;
            height: 16px;

            border-radius: 1px;
            background-color: #7ca4c7;

            position: absolute;
            right: -9px;
            top: 6px;
          }
        }
      }

      &_lk {
        margin-left: 25px;
        margin-right: 52px;

        letter-spacing: 0.175px;
        font-size: 12px;
        color: #fff;

        @include respond-down(md) {
          font-size: 10px;
          margin-left: 26px;
          margin-right: 0;
          margin-top: 5px;
        }
      }

      &_lang {
        margin-right: 1px;
        margin-left: 44px;

        @include respond-down(md) {
          margin-left: 0;
          margin-top: 9px;

          font-size: 12px;
        }
      }
    }
  }
}
</style>
